function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1992(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.7,
    height: 10.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 5.13,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.26,
    width: 22.7,
    height: 10.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4942857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 15.49,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.72,
    width: 22.7,
    height: 13.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.283333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 27.57,
    fontFamily: "Arial"
  }, "\n        Glades\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34.42,
    width: 22.7,
    height: 14.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 41.67,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 48.92,
    width: 22.7,
    height: 15.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.89125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 56.485,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 64.05,
    width: 22.7,
    height: 16.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8122222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 72.205,
    fontFamily: "Arial"
  }, "\n        Gilchrist\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.37,
    width: 22.7,
    height: 17.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5520000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 89.25,
    fontFamily: "Arial"
  }, "\n        Dixie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 98.13,
    width: 22.7,
    height: 17.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.22375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 107.02499999999999,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 115.92,
    width: 22.7,
    height: 18.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6571428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 125.22,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 134.51,
    width: 22.7,
    height: 19,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.111111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 144.01,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 153.51,
    width: 22.7,
    height: 23.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.242857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 165.36499999999998,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 177.22,
    width: 22.7,
    height: 23.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 189.11,
    fontFamily: "Arial"
  }, "\n        Gulf\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 201,
    width: 22.7,
    height: 26.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 214.065,
    fontFamily: "Arial"
  }, "\n        Hardee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 227.13,
    width: 22.7,
    height: 26.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 240.385,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 253.64,
    width: 22.7,
    height: 27.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.242857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 267.275,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 280.91,
    width: 22.7,
    height: 27.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 294.63000000000005,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 308.35,
    width: 22.7,
    height: 29.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 322.995,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 337.64,
    width: 22.7,
    height: 30.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 352.72499999999997,
    fontFamily: "Arial"
  }, "\n        DeSoto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 367.81,
    width: 22.7,
    height: 31.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 383.795,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 399.78,
    width: 22.7,
    height: 32.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 416.05999999999995,
    fontFamily: "Arial"
  }, "\n        Hendry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 432.34,
    width: 22.7,
    height: 33.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 449.28,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 466.21,
    width: 22.7,
    height: 38.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 485.24,
    fontFamily: "Arial"
  }, "\n        Okeechobee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 504.27,
    width: 22.7,
    height: 44.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 526.48,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 548.68,
    width: 22.7,
    height: 46.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 571.775,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 594.88,
    width: 22.7,
    height: 50.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 619.915,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 644.95,
    width: 22.7,
    height: 55.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.35,
    y: 672.475,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 0,
    width: 26.2,
    height: 50.66,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.742857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.8,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.9,
    y: 0,
    width: 26.71,
    height: 50.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.815714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.254999999999995,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.61,
    y: 0,
    width: 27.22,
    height: 50.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 89.22,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.83,
    y: 0,
    width: 29.77,
    height: 50.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.252857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.715,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Flagler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.59,
    y: 0,
    width: 33.08,
    height: 50.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.513333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.13,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.67,
    y: 0,
    width: 46.7,
    height: 50.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.783333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.01999999999998,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.38,
    y: 0,
    width: 52.4,
    height: 50.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.443333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.57999999999998,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.77,
    y: 0,
    width: 58.95,
    height: 50.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.628888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.245,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Highlands\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.73,
    y: 0,
    width: 59.66,
    height: 50.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.066
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.56,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.38,
    y: 0,
    width: 72.78,
    height: 50.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.628888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.77,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        St._Johns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.16,
    y: 0,
    width: 80.01,
    height: 50.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.221666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.165,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Indian_River\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.17,
    y: 0,
    width: 81.44,
    height: 50.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.443333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.89,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 617.61,
    y: 0,
    width: 82.39,
    height: 50.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.237142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.8050000000001,
    y: 25.33,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 50.66,
    width: 74.87,
    height: 56.02,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.135000000000005,
    y: 78.67,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 106.68,
    width: 74.87,
    height: 56.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.756666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.135000000000005,
    y: 134.815,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 162.95,
    width: 74.87,
    height: 60.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.55625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.135000000000005,
    y: 193.17499999999998,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 223.4,
    width: 74.87,
    height: 65.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.916666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.135000000000005,
    y: 256.15,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 288.9,
    width: 74.87,
    height: 76.07,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.35875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.135000000000005,
    y: 326.93499999999995,
    fontFamily: "Arial"
  }, "\n        Okaloosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 364.98,
    width: 74.87,
    height: 76.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.318888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.135000000000005,
    y: 403.20000000000005,
    fontFamily: "Arial"
  }, "\n        Charlotte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 441.41,
    width: 74.87,
    height: 84.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.318888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.135000000000005,
    y: 483.425,
    fontFamily: "Arial"
  }, "\n        St._Lucie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 525.45,
    width: 74.87,
    height: 85.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.7175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.135000000000005,
    y: 568.4250000000001,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 611.4,
    width: 74.87,
    height: 88.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.695714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.135000000000005,
    y: 655.6999999999999,
    fontFamily: "Arial"
  }, "\n        Collier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.57,
    y: 50.66,
    width: 78.83,
    height: 89.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.26142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.98499999999999,
    y: 95.32499999999999,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.4,
    y: 50.66,
    width: 89.79,
    height: 89.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.888333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.29500000000002,
    y: 95.32499999999999,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.18,
    y: 50.66,
    width: 100.42,
    height: 89.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.3325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 316.39,
    y: 95.32499999999999,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.61,
    y: 50.66,
    width: 103.44,
    height: 89.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.76142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 418.33000000000004,
    y: 95.32499999999999,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.05,
    y: 50.66,
    width: 108.61,
    height: 89.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.16625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.355,
    y: 95.32499999999999,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 578.66,
    y: 50.66,
    width: 121.34,
    height: 89.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.16625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.3299999999999,
    y: 95.32499999999999,
    fontFamily: "Arial"
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.57,
    y: 139.99,
    width: 125.08,
    height: 100.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.10999999999999,
    y: 190.10000000000002,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.57,
    y: 240.21,
    width: 125.08,
    height: 107.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.8875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.10999999999999,
    y: 293.985,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.57,
    y: 347.76,
    width: 125.08,
    height: 114.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.374285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.10999999999999,
    y: 405.07,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.57,
    y: 462.38,
    width: 125.08,
    height: 115.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.40625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.10999999999999,
    y: 520.005,
    fontFamily: "Arial"
  }, "\n        Sarasota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.57,
    y: 577.63,
    width: 125.08,
    height: 122.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 40.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.10999999999999,
    y: 638.815,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.65,
    y: 139.99,
    width: 136.93,
    height: 131.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.84142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.115,
    y: 205.935,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.58,
    y: 139.99,
    width: 165.7,
    height: 131.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.981666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.42999999999995,
    y: 205.935,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.27,
    y: 139.99,
    width: 174.73,
    height: 131.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.377999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.635,
    y: 205.935,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.65,
    y: 271.87,
    width: 154.15,
    height: 185.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.845833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.725,
    y: 364.735,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.65,
    y: 457.6,
    width: 154.15,
    height: 242.4,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.415000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.725,
    y: 578.8000000000001,
    fontFamily: "Arial"
  }, "\n        Palm_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.8,
    y: 271.87,
    width: 142.97,
    height: 272.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.87125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 448.285,
    y: 408.22,
    fontFamily: "Arial"
  }, "\n        Pinellas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519.77,
    y: 271.87,
    width: 180.23,
    height: 272.7,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.747142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.885,
    y: 408.22,
    fontFamily: "Arial"
  }, "\n        Broward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.8,
    y: 544.57,
    width: 323.2,
    height: 155.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.543000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.4,
    y: 622.2850000000001,
    fontFamily: "Arial"
  }, "\n        Miami-Dade\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1992);
export default __webpack_public_path__ + "static/media/1992.7e0fc4480461e0a770d65c0e561a9278.svg";
export { ForwardRef as ReactComponent };